jQuery(document).ready(function() {
	// load slider for Headslider

	
jQuery('.startslider').slick({
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  fade: true,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 14000 
});


jQuery('.karussellslider3').slick({
  centerMode: true,
  centerPadding: '0px',
  slidesToShow: 1,
  centerPadding: '25vw',  
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '15vw',
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        centerPadding: '15vw',
        slidesToShow: 1
      }
    }
  ] 
});


jQuery('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 339.2 113.2"><path d="M36.1 69.7c2.4-1.8 2.4-4.9 0-6.7 -3.7-3.1-8-1.8-12.9-1.8 -6.1 0-12.2-0.6-18.4-1.8 -4.9-1.2-6.7 6.1-2.4 8 4.9 1.8 10.4 3.1 15.9 3.7C24.4 71.5 31.2 73.4 36.1 69.7z"/><path d="M61.8 70.3c3.7-1.2 6.7-1.8 10.4-2.4 1.8 0 3.7 0.6 5.5 0s3.1-0.6 4.9-1.8c2.4-1.2 2.4-5.5 0-6.7 -4.3-1.8-7.3-1.8-11.6-0.6s-8 1.8-12.2 4.3C55 65.4 57.5 71.5 61.8 70.3z"/><path d="M137 66c1.8-1.2 1.8-4.3 0-6.1 -3.1-2.4-5.5-1.8-9.2-1.8s-6.7 0.6-10.4 0.6c-4.9 0.6-4.9 7.3 0 7.3 3.1 0 6.1 0.6 9.2 0.6C130.3 67.9 133.4 69.1 137 66z"/><path d="M164.6 66.7c6.7-2.4 13.5-1.2 20.2-3.1 3.7-1.2 3.7-6.7 0-8 -7.3-2.4-15.9 0-22.6 4.3C158.5 61.8 160.9 67.9 164.6 66.7z"/><path d="M242.9 62.4c1.2-1.2 1.2-3.7 0-4.9 -3.7-3.7-8.6-2.4-13.5-2.4 -4.3 0-9.2 0-13.5 0.6 -3.7 0.6-3.7 6.7 0 7.3 4.3 0.6 8 0.6 12.2 0.6C233.1 64.8 238.6 66 242.9 62.4z"/><path d="M295.5 56.2c0-3.7-3.7-6.1-6.7-4.9 -4.9 1.2-11 1.2-15.9 1.8 -3.1 0.6-3.1 6.1 0 6.7 5.5 0.6 11 0 15.9 1.8C291.9 62.4 295.5 59.9 295.5 56.2z"/><path d="M298 103.4c15.3-14.1 30.6-29.4 40.4-48.3 1.2-2.4 1.2-5.5-1.2-7.3 -15.3-12.9-32.4-22.6-47.1-36.1 -4.9-4.9-12.2 3.1-7.3 7.3 13.5 12.2 29.4 21.4 42.8 33.7 -9.8 15.9-23.9 26.9-36.7 41C282.7 100.3 291.9 108.9 298 103.4z"/></svg>').appendTo( ".karussellslider3 .slick-next , .karussellslider3 .slick-prev");	

});